import React from "react";
import styled from "@emotion/styled";

import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";

import { Typography, Box, Container } from "@mui/material";

import { getTheme, Tenant } from "@finanzcheck/teal-mui-theme";
import { TealHeader, PhoneBox } from "@finanzcheck/teal-components";

import "./App.css";

const theme = getTheme(Tenant.Smava);

const MaintenanceLogo = styled(Box)`
  margin-top: 70px;
  margin-bottom: 30px;
  width: 200px;
  height: 200px;

  ${theme.breakpoints.up("md")} {
    margin-top: 100px;
    width: 280px;
    height: 280px;
  }
` as typeof Box;

const Headline = styled(Typography)`
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 10px;

  ${theme.breakpoints.up("md")} {
    font-size: 24px;
    line-height: 35px;
  }
` as typeof Typography;

const Subline = styled(Typography)`
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 24px;

  ${theme.breakpoints.up("md")} {
    font-size: 16px;
  }
` as typeof Typography;

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MUIThemeProvider theme={theme}>
          <EmotionThemeProvider theme={theme}>
            <TealHeader contentRight={<PhoneBox />} />

            <Container>
              <MaintenanceLogo
                component="img"
                alt="Frau in grüner Latzhose bei Malerarbeiten"
                src="/error/500/maintenance.svg"
              />
              <Headline variant="h4">
                Diese Website wird gerade überarbeitet.
              </Headline>
              <Subline variant="body2">Wir sind in Kürze zurück.</Subline>
            </Container>
          </EmotionThemeProvider>
        </MUIThemeProvider>
      </header>
    </div>
  );
}

export default App;
